export default "__VITE_ASSET__BR46Oy9V__"